<div class="content">
  <div class="content-panel">

    <div *ngIf="firstLoad">
      Chargement des données...
    </div>

    <div *ngIf="loaded" class="param-emails-layout">

      <div class="param-emails-sidebar">

        <div class="form-group">
          <label>Catégorie du document</label>

          <select
            class="form-control"
            [(ngModel)]="selectedCategorie"
            (ngModelChange)="onCategorieChange()">

            <option [ngValue]="null">
              Sélectionner une catégorie
            </option>

            <option
              *ngFor="let categorie of categorieBalises"
              [ngValue]="categorie">
              {{ categorie.libelle }}
            </option>

          </select>
        </div>

        <button
          type="button"
          class="btn btn-primary full-width"
          [disabled]="!selectedCategorie"
          (click)="nouveauTemplate()">
          Nouveau template
        </button>

        <div class="form-group" *ngIf="selectedCategorie">
          <label>Template existant</label>

          <select
            class="form-control"
            [(ngModel)]="selectedDocument"
            (ngModelChange)="onDocumentChange()">

            <option [ngValue]="null">
              Sélectionner un template
            </option>

            <option
              *ngFor="let template of templatesFiltres"
              [ngValue]="template">
              {{ template.libelle }}
              <ng-container *ngIf="!template.idOrganisme">
                — général
              </ng-container>
            </option>

          </select>
        </div>

        <div class="balises-panel" *ngIf="selectedCategorie">

          <h3>Balises disponibles</h3>

          <p class="help-text">
            Cliquez sur une balise pour l’insérer dans le template.
          </p>

          <div *ngIf="balisesFiltrees.length === 0">
            Aucune balise disponible pour cette catégorie.
          </div>

          <button
            type="button"
            class="balise-button"
            *ngFor="let balise of balisesFiltrees"
            [disabled]="disableEditor"
            (click)="insererBalise(balise)">

            {{ balise.libelle }}
            <span>{{ balise.code }}</span>

          </button>

        </div>

      </div>

      <div class="param-emails-editor">

        <div *ngIf="!selectedDocument" class="empty-state">
          Sélectionnez une catégorie puis un template, ou créez un nouveau template.
        </div>

        <div *ngIf="selectedDocument">

          <h2 *ngIf="!isCreationMode">
            Modification du template : {{ selectedDocument.libelle }}
          </h2>

          <h2 *ngIf="isCreationMode">
            Création d’un nouveau template
          </h2>

          <div class="template-form">

            <div class="form-group">
              <label>Libellé du template</label>

              <input
                type="text"
                class="form-control"
                [(ngModel)]="selectedDocument.libelle"
                placeholder="Exemple : Notification document Innov">
            </div>

            <div class="form-group">
              <label>Organisme</label>

              <select
                class="form-control"
                [(ngModel)]="selectedOrganisme">

                <option [ngValue]="null">
                  Tous les organismes
                </option>

                <option
                  *ngFor="let organisme of organismesFiltres"
                  [ngValue]="organisme">
                  {{ organisme.raisonSociale }}
                </option>

              </select>

              <p class="help-text">
                Si aucun organisme n’est sélectionné, ce template sera disponible pour tous les organismes.
              </p>
            </div>

          </div>

          <editor
            apiKey="1s37c5uwcd5w0a3fskzjjg1oc691h8irkmmcdzurqfu1xoj5"
            [(ngModel)]="editorContent"
            [init]="tinyMceConfig"
            [disabled]="disableEditor">
          </editor>

          <div class="actions">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="annulerModification()">
              Annuler
            </button>

            <button
              type="button"
              class="btn btn-primary"
              [disabled]="!selectedDocument.libelle || !selectedCategorie"
              (click)="enregistrerTemplate()">

              {{ isCreationMode ? 'Créer le template' : 'Enregistrer les modifications' }}

            </button>
          </div>

        </div>

      </div>

    </div>

  </div>
</div>